/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { UiInputAxis_Enum, uiInputAxis_EnumFromJSON, uiInputAxis_EnumToJSON } from "./ui_input_axis";

export const protobufPackage = "skills";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface UiAxis {
  axis: UiInputAxis_Enum;
  value: number;
}

function createBaseUiAxis(): UiAxis {
  return { axis: 0, value: 0 };
}

export const UiAxis = {
  encode(message: UiAxis, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.axis !== 0) {
      writer.uint32(8).int32(message.axis);
    }
    if (message.value !== 0) {
      writer.uint32(21).float(message.value);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UiAxis {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUiAxis();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.axis = reader.int32() as any;
          continue;
        case 2:
          if (tag !== 21) {
            break;
          }

          message.value = reader.float();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UiAxis {
    return {
      axis: isSet(object.axis) ? uiInputAxis_EnumFromJSON(object.axis) : 0,
      value: isSet(object.value) ? globalThis.Number(object.value) : 0,
    };
  },

  toJSON(message: UiAxis): unknown {
    const obj: any = {};
    if (message.axis !== 0) {
      obj.axis = uiInputAxis_EnumToJSON(message.axis);
    }
    if (message.value !== 0) {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UiAxis>, I>>(base?: I): UiAxis {
    return UiAxis.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UiAxis>, I>>(object: I): UiAxis {
    const message = createBaseUiAxis();
    message.axis = object.axis ?? 0;
    message.value = object.value ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
